import React, { useEffect, useState } from "react";
import { PreviewContainer, PreviewModeContainer } from "./PreviewMode.style";
import { TRichTextValue } from "../App.type";
import parse from "html-react-parser";
import { PageHelper, UrlHelper } from "@tpd-web-common-libs/nodejs-library/dist/src/helpers";

type TPreviewModeProps = {
  value: TRichTextValue;
  componentType?: string;
};

const ComponentTypes = ["h1", "h2"];

const PreviewMode = (props: TPreviewModeProps) => {
  const {
    value: { value: text },
    componentType,
  } = props;

  const [richText, setRichText] = useState(text);

  const imgContainer = () => {
    return text.includes("<img");
  };

  const RichTextContent = () => {
    let htmlObject = parse(text);
    htmlObject = React.createElement(
      componentType,
      {},
      htmlObject.props?.children ? htmlObject.props.children : htmlObject
    );

    return (
      <PreviewModeContainer
        className={`rich-text-preview-mode-container ${
          imgContainer() ? "img-container" : ""
        }`}
        style={{ width: "100%" }}
      >
        {htmlObject}
      </PreviewModeContainer>
    );
  };

  const updateHrefAttributes = () => {
    const projectName = UrlHelper.getProjectNameFromUrl();
    if (projectName) {
      // Regular expression to match <a> tags
      const aTagRegex = /<a\b[^>]*>(.*?)<\/a>/gi;
      // Regular expression to match href attribute within an <a> tag
      const hrefRegex = /href\s*=\s*["']([^"']+)["']/i;

      // Find all matches in the input string
      const matches = text.match(aTagRegex);

      // If no matches found, return the original string
      if (!matches) {
        return text;
      }

      let updatedString = text;

      matches.map(tag => {
        const hrefMatch = tag.match(hrefRegex);
        if (hrefMatch) {
          const originalHref = hrefMatch[1];
          if (originalHref.match(/^\/tpdweb\/?/)) {
            const newHref = `/myportal/$project/${projectName}${originalHref}`;
            const updatedTag = tag.replace(hrefMatch[0], `href="${newHref}"`);
            updatedString = updatedString.replace(tag, updatedTag);
          }
        }
      });
      return updatedString;
    }
    return text;
  }

  useEffect(() => {
    if (PageHelper.isHCLAuthoringPage() && text) {

      const updatedRichText = updateHrefAttributes();
      setRichText(updatedRichText);
    }
    
  }, []);

  return (
    <PreviewContainer>
      {text && componentType && ComponentTypes.includes(componentType) ? (
        <RichTextContent />
      ) : (
        <PreviewModeContainer
          className={`rich-text-preview-mode-container ${
            imgContainer() ? "img-container" : ""
          }`}
          style={{ width: "100%" }}
          dangerouslySetInnerHTML={{ __html: richText }}
        />
      )}
    </PreviewContainer>
  );
};

export default PreviewMode;
